import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { delay } from 'rxjs/operators';
import moment from 'moment';

import { Address, Country, FatcaManager, FullClient } from '../../../domain/data';
import { BaseUI } from '../../base.ui';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { FatcaManagerCompanyRelation, GetCountriesUseCase } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';


@Component({
    selector: 'thr-full-data-five-legal-person',
    templateUrl: './full-data-five-legal-person.component.html',
    styleUrls: ['./full-data-five-legal-person.component.scss']
})
export class FullDataFiveLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public FatcaManagerCompanyRelation: typeof FatcaManagerCompanyRelation = FatcaManagerCompanyRelation;

    public form: NgForm;
    public isFormValid = false;

    public editing = false;
    public currentFatcaManager: FatcaManager;

    public today = moment();
    public hundredYears = moment().subtract(100, 'years');
    public countries: Country[] = [];

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;


    constructor(parentEvents: ParentEvents,
                private dialog: MatDialog,
                private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase.bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe(transaction => {
                if (transaction.isSuccess) {
                    this.countries = (transaction.data as Country[]);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = (this.formDirective.controlContainer as NgForm);

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onResize() {
        this.parentEvents.resize();
    }

    onSave() {
        if (this.editing) {
            this.client.fatca.updateManager(this.currentFatcaManager);
        }

        this.onCancel();
    }

    onCancel() {
        this.editing = false;
        this.currentFatcaManager = undefined;

        this.parentEvents.resize();
    }

    onEdit(manager: FatcaManager) {
        this.editing = true;
        this.currentFatcaManager = cloneDeep(manager);
    }

    onHabitualResidenceChange() {
        if (this.currentFatcaManager.isEqualMailAddress) {
            this.currentFatcaManager.mailResidence = cloneDeep(this.currentFatcaManager.habitualResidence);
        }
    }

    onEqualMailAddressChange() {
        if (this.currentFatcaManager.isEqualMailAddress) {
            this.currentFatcaManager.mailResidence = cloneDeep(this.currentFatcaManager.habitualResidence);
        } else {
            this.currentFatcaManager.mailResidence = new Address();
        }

        this.parentEvents.resize();
    }
}
